var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5977 3.44394C11.8494 2.66931 12.9453 2.66931 13.197 3.44394L14.8513 8.53553C14.9639 8.88196 15.2867 9.1165 15.651 9.1165L21.0046 9.11651C21.8191 9.11651 22.1577 10.1588 21.4988 10.6375L17.1676 13.7843C16.8729 13.9984 16.7496 14.3779 16.8622 14.7243L18.5166 19.8159C18.7682 20.5905 17.8816 21.2347 17.2227 20.7559L12.8915 17.6092C12.5969 17.3951 12.1978 17.3951 11.9031 17.6092L7.57197 20.7559C6.91303 21.2347 6.02644 20.5905 6.27813 19.8159L7.93249 14.7243C8.04505 14.3779 7.92174 13.9984 7.62705 13.7843L3.29589 10.6375C2.63695 10.1588 2.9756 9.11651 3.79009 9.11651L9.1437 9.1165C9.50796 9.1165 9.83078 8.88196 9.94334 8.53553L11.5977 3.44394Z",
    fill: "#00DBFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.f840195434f72833bed07d15a4d2c8fa.svg";
export { ForwardRef as ReactComponent };